import { createLucideIcon } from "lucide-react";

export const HelpCircle = createLucideIcon(
    "HelpCircle",
    [
        [
            "path",
            {
                d: "M10 9C10 7.89543 10.8954 7 12 7C13.1046 7 14 7.89543 14 9C14 9.39815 13.8837 9.76913 13.6831 10.0808C13.0854 11.0097 12 11.8954 12 13V13.5",
                key: "n4v9fv",
            },
        ],
        [
            "path",
            {
                d: "M11.992 17H12.001",
                key: "10b27f",
            },
        ],
        [
            "circle",
            {
                cx: "12",
                cy: "12",
                key: "1mglay",
                r: "10",
            },
        ],
    ],
);
